export default __webpack_public_path__ + "static/dressesHeader-81e42a4d1875f8c308ce56263582e755.jpg";